import { render } from "./SpanColla.vue?vue&type=template&id=9f0e0a8c"
import script from "./SpanColla.vue?vue&type=script&lang=js"
export * from "./SpanColla.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__